/**
 * @generated SignedSource<<48279a7e5d657ab9829416255e269945>>
 * @relayHash 83b924a91471da3aea21fcee877e165c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a873ccdebaf84ede3481fa8d215f59dc17cb2681deff9845e27d0ca2d6ebbabc

import type { ConcreteRequest } from 'relay-runtime';
export type OnboardingStateInput = {
  key: string;
  value: string;
};
export type OnboardingStatusMutation$variables = {
  states: ReadonlyArray<OnboardingStateInput>;
};
export type OnboardingStatusMutation$data = {
  readonly setOnboardingState: ReadonlyArray<{
    readonly key: string;
    readonly value: string | null | undefined;
  }> | null | undefined;
};
export type OnboardingStatusMutation = {
  response: OnboardingStatusMutation$data;
  variables: OnboardingStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "states"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "states",
        "variableName": "states"
      }
    ],
    "concreteType": "OnboardingState",
    "kind": "LinkedField",
    "name": "setOnboardingState",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OnboardingStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "83b924a91471da3aea21fcee877e165c",
    "id": "a873ccdebaf84ede3481fa8d215f59dc17cb2681deff9845e27d0ca2d6ebbabc",
    "metadata": {},
    "name": "OnboardingStatusMutation",
    "operationKind": "mutation",
    "text": "mutation OnboardingStatusMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
  }
};
})();

(node as any).hash = "2e0e7fd20fb93789a04b333aa047f2cd";

export default node;
